import { Box } from "@mui/joy";
import { UserType } from "recoil/userAtom";
import LinkV2 from "../common/LinkV2";
import useUnifiedNavigate from "../../hooks/useUnifiedNavigate";

export default function UserInfo({ user }: { user: UserType }) {
  const navigate = useUnifiedNavigate();

  return (
    <Box
      onClick={() =>
        navigate("/mypage/account", {
          type: "card",
          gestureEnabled: true,
          animation: "default",
        })
      }
    >
      <LinkV2 text={"계정"} />
    </Box>
  );
}
